/**
 * Indicates whether a given timestamp was manually captured.
 * tag: 2839
 * @readonly
 * @enum {string} (Boolean)
 */
export enum TrdRegTimestampManualIndicator {
  /** Not manually captured */
  NotManuallyCaptured = 'N',
  /** Manually captured */
  ManuallyCaptured = 'Y',
}
